export default {
  AVAILABLE: "available",
  DO_NOT_DISTURB: "do_not_disturb",
  UNAVAILABLE: "unavailable",
  UNKNOWN: "unknown",
};
